module.exports = __webpack_public_path__ + "static/iberdrola-a8b662a5463851d9d10bf48e50333f4f.svg";